import { ALTERAR_REGISTROS_POR_PAGINA_USUARIO } from '../types'

export default function alterarRegistrosPorPaginaUsuarios (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_USUARIO,
    payload: valor
  }
}
